import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DETALHES_DESTINO, LISTA_DESTINO} from '../constants/destino.constant';

@Injectable({
    providedIn: 'root'
})
export class DestinoService extends BaseService {

    constructor(private httpClient: HttpClient) {
        super(httpClient);
    }

    private detalhesDestinos = {
        destinos: DETALHES_DESTINO
    };

    public listaDestinos() {
        try {
            return {
                destinos: LISTA_DESTINO
            };
        } catch (e) {
            return null;
        }
    }

    public getDetalheDestino(slug) {
        try {
            return this.detalhesDestinos.destinos.filter(c => c.slug === slug)[0];
        } catch (e) {
            return null;
        }
    }
}
